import { useQuery } from "react-query";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo, useState } from "react";
import { Delete, Edit } from "@mui/icons-material";
import CustomPagination from "../../shared/CustomPagination";
import { getSpecifications } from "../../Services/Specifications";
import DeleteSpecificationModal from "./DeleteSpecificationModal";

const tableHeader = [
  "S. No",
  "Category",
  "Specification Type",
  "Specification",
  "Actions",
];

const TableHeaderComponent = () => {
  return (
    <TableHead>
      <TableRow>
        {tableHeader.map((item, idx) => {
          return (
            <TableCell
              className="!font-semibold border-2 !border-slate-200"
              align="center"
              key={idx}
            >
              {item}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

const SpecificationsTable = ({ search, setIsModalOpen, setRowData, id }) => {
  const [page, setPage] = useState(1);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState();
  const { data: specificationTypeData } = useQuery(
    [`specifications_values`, search, page, id],
    () => getSpecifications({ search, page, product_specification: id })
  );

  const specifications = useMemo(
    () => specificationTypeData?.data?.data,
    [specificationTypeData]
  );

  return (
    <>
      <TableContainer component={Paper} className="!bg-white">
        <Table>
          <TableHeaderComponent />
          <TableBody>
            {specifications?.map(
              (
                { id, category_name, specification, specification_type },
                idx
              ) => {
                return (
                  <TableRow key={idx}>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {idx + 1 + (page - 1) * 10}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {category_name}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {specification_type}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {specification}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      <div className="flex flex-row justify-center gap-2">
                        <Edit
                          className="text-green-500 cursor-pointer"
                          onClick={() => {
                            setRowData({
                              category_name,
                              specification_type,
                              specification,
                              id,
                            });
                            setIsModalOpen(true);
                          }}
                        />
                        <Delete
                          className="text-red-500 cursor-pointer"
                          onClick={() => {
                            setIsDeleteModalOpen(true);
                            setIdToDelete(id);
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DeleteSpecificationModal
        open={isDeleteModalOpen}
        setOpen={setIsDeleteModalOpen}
        idToDelete={idToDelete}
      />
      <CustomPagination data={specificationTypeData} setPage={setPage} />
    </>
  );
};

export default SpecificationsTable;
